/**
 * NOTE: Be sure to document new items in https://confluence.netx.net/display/DEV/X7+Library+Overrides%2C+Extensions+and+Mixins
 */
+function( $ ) {
	
	// https://github.com/select2/select2/issues/1436
	//$.fn.modal.Constructor.prototype.enforceFocus = function() {};
	
	// // Prevent dropdown from closing under certain conditions
	// $(document).on('hide.bs.dropdown', function (e) {
	// 	var $target = $(e.target);
	// 	if( $target.find('.nx-popover-open').length ) {
	// 		return false;
	// 	}
	// } );
	
	// Interesting, Safari is behaving correctly on this (by not positioning tootlips correctly) - offsetWidth/offsetHeight are returned for SVG elements in all other browsers
	// https://bugs.chromium.org/p/chromium/issues/detail?id=463116
	// https://drafts.csswg.org/cssom-view/#dom-htmlelement-offsetheight / https://drafts.csswg.org/cssom-view/#dom-htmlelement-offsetwidth
	// Both assume the css box model which SVG is not - so we constantly come up {left:0,top:0} in safari no matter what when `jQuery.fn.offset` is used
	// Part of me thinks I ought to override jQuery offset and use `getBoundingClientRect` in the event of an SVG element
	// but since this problem only is affecting us with tooltips in stats at the moment, bootstrap override:
	$.fn.tooltip.Constructor.prototype.getPosition = function ($element) {
		$element   = $element || this.$element;
		var el     = $element[0];
		var isBody = el.tagName == 'BODY';
		
		var hasBoundingClientRect = _.isFunction( el.getBoundingClientRect );
		var svgRelated = $element.is('svg') || $element.closest('svg').length;
		
		if( svgRelated && !hasBoundingClientRect ) {
			console.warn("Bootstrap tooltip: element is SVG and does not have boundingClientRect - positions cannot be calculated.");
		}
		
		var boundingClientRect = hasBoundingClientRect ? el.getBoundingClientRect() : $element.offset();
		return $.extend({}, hasBoundingClientRect && boundingClientRect || null, {
			scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop(),
			width:  isBody ? $(window).width()  : $element.outerWidth(),
			height: isBody ? $(window).height() : $element.outerHeight()
		}, isBody ? { top: 0, left: 0 } : svgRelated && _.pick( boundingClientRect, 'left', 'top' ) || $element.offset() );
	}
	
}( jQuery );